﻿if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        window.setTimeout(() => this.filterByVariantSku(this.getSelectedVariantSkuFromPage()), 0);
        window.setTimeout(() => this.filterByVariantSku(this.getSelectedVariantSkuFromPage()), 500);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }
      getSelectedVariantSkuFromPage() {
        const selectedVariantJson = document.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (!selectedVariantJson) return '';
        try {
          return JSON.parse(selectedVariantJson)?.sku || '';
        } catch (error) {
          return '';
        }
      }

      getSkuFromMediaItem(item) {
        const altText = item?.querySelector('img[alt]')?.getAttribute('alt') || '';
        const match = altText.match(/^([^|]+?)\s*\|\s*.+$/);
        return match ? match[1].trim() : '';
      }

      getSkuMediaRoleOrder(item) {
        const altText = item?.querySelector('img[alt]')?.getAttribute('alt') || '';
        const role = altText.split('|').slice(1).join('|').trim();
        if (role === 'main') return 0;
        if (role === 'dimension') return 1;
        if (role === 'package') return 2;
        if (role === 'table-detail') return 3;
        const chairDetailMatch = role.match(/^chair-detail-(\d+)$/);
        if (chairDetailMatch) return 10 + Number(chairDetailMatch[1]);
        return 99;
      }

      reorderSkuScopedMedia(viewerItems) {
        const visibleViewerItems = viewerItems
          .filter((item) => !item.hidden)
          .sort((a, b) => this.getSkuMediaRoleOrder(a) - this.getSkuMediaRoleOrder(b));
        const viewerParent = visibleViewerItems[0]?.parentElement;
        visibleViewerItems.forEach((item) => viewerParent?.appendChild(item));

        if (!this.elements.thumbnails) return visibleViewerItems;

        const thumbnailsByTarget = new Map(
          Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).map((thumbnail) => [
            thumbnail.dataset.target,
            thumbnail,
          ])
        );
        const visibleThumbnails = visibleViewerItems
          .map((item) => thumbnailsByTarget.get(item.dataset.mediaId))
          .filter(Boolean);
        const thumbnailParent = visibleThumbnails[0]?.parentElement;
        visibleThumbnails.forEach((thumbnail) => thumbnailParent?.appendChild(thumbnail));

        return visibleViewerItems;
      }

      filterByVariantSku(variantSku) {
        if (!variantSku || !this.elements.viewer) return;

        const viewerItems = Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
        const mediaSkuById = new Map(
          viewerItems.map((item) => [item.dataset.mediaId, this.getSkuFromMediaItem(item)])
        );
        const hasSkuScopedMedia = Array.from(mediaSkuById.values()).some(Boolean);
        if (!hasSkuScopedMedia) return;

        viewerItems.forEach((item) => {
          const mediaSku = mediaSkuById.get(item.dataset.mediaId);
          item.hidden = mediaSku !== variantSku;
          item.classList.toggle('sumdeal-sku-media-hidden', item.hidden);
          if (item.hidden) item.classList.remove('is-active');
        });

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumbnail) => {
            const mediaSku = mediaSkuById.get(thumbnail.dataset.target);
            thumbnail.hidden = mediaSku !== variantSku;
            thumbnail.classList.toggle('sumdeal-sku-media-hidden', thumbnail.hidden);
            if (thumbnail.hidden) thumbnail.querySelector('button')?.removeAttribute('aria-current');
          });
        }

        const visibleViewerItems = this.reorderSkuScopedMedia(viewerItems);
        const mainVisibleItem = visibleViewerItems.find((item) => {
          const imageAlt = item.querySelector('img[alt]')?.getAttribute('alt') || '';
          return !item.hidden && imageAlt.trim() === `${variantSku} | main`;
        });
        const activeVisibleItem = visibleViewerItems.find((item) => item.classList.contains('is-active') && !item.hidden);
        const firstVisibleItem = visibleViewerItems[0];
        if (mainVisibleItem) {
          this.setActiveMedia(mainVisibleItem.dataset.mediaId, false);
        } else if (!activeVisibleItem && firstVisibleItem) {
          this.setActiveMedia(firstVisibleItem.dataset.mediaId, false);
        }

        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        if (this.elements.thumbnails?.slider) this.elements.thumbnails.slider.resetPages?.();
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

